/**
 * DEPRECATED use SDUIText
 */
export enum TextDecorator {
  TEXT_DECORATOR_UNKNOWN = 'TEXT_DECORATOR_UNKNOWN',
  EMPHASIS = 'EMPHASIS',
  STRIKE_THROUGH = 'STRIKE_THROUGH',
  UNDERLINE = 'UNDERLINE',
}
